import {classNames, layout, PushButton, theme, View, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useMemo} from "react";
import {stylesheet} from "typestyle";
import {Category, Product} from "./types";
import {VendingViewHeader} from "./header";
import {Inventory} from "./inventory";
import {useLocalization} from "../i18n";

export interface ProductsViewProps {
    inventory: Inventory;
    category: Category;
    product: Product;
    onVend: (product: Product) => any;
    onBack: () => void;
}

export function ProductView({inventory, category, product, onVend, onBack}: ProductsViewProps) {
    const {t} = useLocalization();
    const handleBuy = useCallback(() => onVend(product), [onVend, product]);
    const inStock = useMemo(() => inventory.getCount(product) > 0, [inventory, product]);
    return (
        <View>
            <VendingViewHeader
                title={`${category.name} > ${product.name}`}
                onBack={onBack}
            />
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={classNames(layout.horizontal)}>
                    <div className={classNames(theme.moreContrast, layout.vertical, styles.boxLeft)}>
                        <div className={styles.imageContainer}>
                            <img src={product.image} alt={product.name} className={styles.image} />
                        </div>
                    </div>
                    <div
                        className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxRight)}>
                        <div className={styles.name}>
                            {product.name}
                        </div>
                        <div className={styles.description}>
                            {product.description}
                        </div>
                        <div className={styles.description}>
                            € {product.price.gross.toFixed(2)}
                        </div>
                        <div>
                            {!inStock && (
                                <PushButton
                                    className={classNames(styles.button, styles.marginBottom)}
                                    onClick={onBack}
                                >
                                    {t("OutOfStock")}
                                </PushButton>
                            )}
                            {inStock &&
                                <PushButton
                                    primary
                                    className={classNames(styles.button, styles.marginBottom)}
                                    onClick={handleBuy}
                                >
                                    {t("Buy")}
                                </PushButton>
                            }
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    boxLeft: {
        width: "24em"
    },
    boxRight: {
        width: "20em",
        padding: "1.5em"
    },
    button: {
        width: "100%"
    },
    backButton: {
        marginTop: "0.7rem",
        marginBottom: "0.7rem"
    },
    marginBottom: {
        marginBottom: "0.5rem"
    },
    name: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.25em",
    },
    description: {
        flexGrow: 1,
        paddingTop: "1.5em",
        paddingBottom: "1.5em",
        whiteSpace: "pre-wrap"
    },
    imageContainer: {
        height: "22em",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1em"
    },
    image: {
        height: "100%",
        maxHeight: "100%",
        width: "auto"
    },
});
